<div class="ce-page">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="ce-loading" *ngIf="!ready">
    <div class="ce-loading__icon"><mat-icon>person</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="ce-loading__text">Cargando formulario…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER ─────────────────────────────────────────────── -->
    <div class="ce-header">
      <div class="ce-header__icon"><mat-icon>person</mat-icon></div>
      <div>
        <h1 class="ce-header__title">{{ creditosConEmpleados.uid ? 'Editar crédito con empleado' : 'Nuevo crédito con empleado' }}</h1>
        <p class="ce-header__sub">{{ creditosConEmpleados.uid ? 'Modifica los datos del crédito' : 'Registra un nuevo crédito con empleado' }}</p>
      </div>
      <button mat-flat-button class="ce-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="ce-body">
      <form onkeypress="return event.keyCode != 13;">
        <div class="ce-grid">

          <!-- COLUMNA IZQUIERDA -->
          <div class="ce-left">

            <!-- SECCIÓN: Empleado -->
            <div class="ce-section">
              <div class="ce-section__head">
                <mat-icon>perm_identity</mat-icon>
                <span>Empleado</span>
              </div>
              <div class="ce-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Empleado</mat-label>
                  <input matInput [(ngModel)]="creditosConEmpleados.employeesName"
                    name="creditosConEmpleados.employeesName"
                    [matAutocomplete]="auto" [formControl]="employeesControl" required [readonly]="readOnly"
                    matTooltip="Recuerda seleccionar el empleado de la lista">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let employee of employeesfiltered | async; trackBy: trackByIndex" [value]="employee.name"
                      (click)="setEmployeeIdentifier(employee.uid)">
                      {{ employee.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

              </div>
            </div>

            <!-- SECCIÓN: Plazos -->
            <div class="ce-section">
              <div class="ce-section__head">
                <mat-icon>date_range</mat-icon>
                <span>Plazos</span>
              </div>
              <div class="ce-section__body">

                <div class="ce-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de constitución</mat-label>
                    <input matInput [matDatepicker]="fechaConstitucion"
                      name="creditosConEmpleados.fechaConstitucion"
                      [(ngModel)]="creditosConEmpleados.fechaConstitucion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaConstitucion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaConstitucion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Plazo (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="creditosConEmpleados.plazo"
                      name="creditosConEmpleados.plazo" required>
                  </mat-form-field>
                </div>

                <div class="ce-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de finalización</mat-label>
                    <input matInput [matDatepicker]="fechaFinalizacion"
                      name="creditosConEmpleados.fechaFinalizacion"
                      [(ngModel)]="creditosConEmpleados.fechaFinalizacion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaFinalizacion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaFinalizacion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Carencia (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="creditosConEmpleados.carencia"
                      name="creditosConEmpleados.carencia" required>
                  </mat-form-field>
                </div>

              </div>
            </div>

          </div>

          <!-- COLUMNA DERECHA -->
          <div class="ce-right">

            <!-- SECCIÓN: Importes y condiciones -->
            <div class="ce-section">
              <div class="ce-section__head">
                <mat-icon>attach_money</mat-icon>
                <span>Importes y condiciones</span>
              </div>
              <div class="ce-section__body">

                <div class="ce-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe inicial</mat-label>
                    <input matInput type="text" [(ngModel)]="creditosConEmpleados.importeInicial"
                      name="creditosConEmpleados.importeInicial" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe pendiente</mat-label>
                    <input matInput type="text" [(ngModel)]="creditosConEmpleados.importePendiente"
                      name="creditosConEmpleados.importePendiente" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tipo de interés</mat-label>
                  <input matInput type="text" [(ngModel)]="creditosConEmpleados.tipoInteres"
                    name="creditosConEmpleados.tipoInteres" numberDecimalsDirective required>
                </mat-form-field>

              </div>
            </div>

            <!-- SECCIÓN: Liquidaciones y cuenta -->
            <div class="ce-section">
              <div class="ce-section__head">
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Liquidaciones y cuenta</span>
              </div>
              <div class="ce-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tipo de liquidaciones</mat-label>
                  <mat-select [(ngModel)]="creditosConEmpleados.tipoLiquidaciones" name="tipoLiquidaciones" required>
                    <mat-option [value]="0">Sin seleccionar</mat-option>
                    <mat-option [value]="1">Mensual</mat-option>
                    <mat-option [value]="2">Bimensual</mat-option>
                    <mat-option [value]="3">Trimestral</mat-option>
                    <mat-option [value]="4">Semestral</mat-option>
                    <mat-option [value]="5">Anual</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-autocomplete-select [items]="bankAccounts"
                  [(selectedItemId)]="creditosConEmpleados.bankAccountsUid"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']"
                  placeholder="Cuenta de abono" class="w-100">
                </app-autocomplete-select>

              </div>
            </div>

          </div>

        </div>
      </form>
    </div>

  </ng-container>

</div>
